//---WATER BATH-----------------------------:
export const createWaterBath= (data) => {
  //data = {id, type}
  return { type: "CREATE_WATER_BATH", payload: data}
}

export const addItemToWaterBath = (data) => {
  //data = {newItem} newItem = {type, id}
  return { type: "ADD_ITEM_TO_WATER_BATH", payload: data }
}

export const removeItemFromWaterBath = (data) => {
  //data = {removeItem} removeItem = {type,id}
  return { type: "REMOVE_ITEM_FROM_WATER_BATH", payload: data }
}

export const waterBathOpen = (data) => {
  //data = {open}
  return { type: "WATER_BATH_OPEN", payload: data }
}

export const setWaterBathTime = (data) => {
  //data = {time}
  return { type: "SET_WATER_BATH_TIME", payload: data }
}

export const waterBathCountdown = (data) => {
  //data = {timeDiff}
  return { type: "WATER_BATH_COUNT_DOWN", payload: data }
}

export const setWaterBathTemp = (data) => {
  //data = {temp}
  return { type: "SET_WATER_BATH_TEMP", payload: data }
}

export const waterBathCountdownActive = (data) => {
  //data = {active}
  return { type: "WATER_BATH_COUNTDOWN_ACTIVE", payload: data }
}

export const waterBathContainsTubeRack = (data) => {
  //data = {containsTubeRack}
  return { type: "WATER_BATH_CONTAINS_TUBE_RACK", payload: data }
}

export const toggleToolTipControlsForWaterBath = data => {
  return { type: "SHOW_TOOL_TIP_CONTROLS_WATER_BATH", payload: data };
};

